const brand = process.env.REACT_APP_BRAND || 'circleloop';

const dev = {
    production:false,
    websocket:"wss://dev-ls.kumodi.com",
    Intercom:"yw7m4vp8",
    url: 1===2 ? `http://localhost:8000/${brand}` : `https://dev-api.kumodi.com/${brand}`
}

const production = {
    production:true,
    websocket:"wss://ls.kumodi.com",
    url:`https://api.kumodi.com/${brand}`,
    Intercom:"dmr5ygcr"
}

export default process.env.REACT_APP_API_ENV === 'PRODUCTION' ? production : dev;


// WEBPACK FOOTER //
// ./src/config.js